__turbopack_context__.v({
  "anchor": "FirstRunIntroduction-module__lCGRvW__anchor",
  "character": "FirstRunIntroduction-module__lCGRvW__character",
  "comma": "FirstRunIntroduction-module__lCGRvW__comma",
  "content": "FirstRunIntroduction-module__lCGRvW__content",
  "glyph": "FirstRunIntroduction-module__lCGRvW__glyph",
  "latin": "FirstRunIntroduction-module__lCGRvW__latin",
  "letter": "FirstRunIntroduction-module__lCGRvW__letter",
  "name": "FirstRunIntroduction-module__lCGRvW__name",
  "nameSlot": "FirstRunIntroduction-module__lCGRvW__nameSlot",
  "opening": "FirstRunIntroduction-module__lCGRvW__opening",
  "question": "FirstRunIntroduction-module__lCGRvW__question",
  "sentence": "FirstRunIntroduction-module__lCGRvW__sentence",
  "subject": "FirstRunIntroduction-module__lCGRvW__subject",
  "suffix": "FirstRunIntroduction-module__lCGRvW__suffix",
});
